<template>
    <Head :title="'Utilisateur N°'+ userShow.code" />

    <UserLayout :userShow="userShow" :roles="roles" :currency="currency">
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Liste des demandes d'envoie de colis
                    <span class="font-medium">({{ requests.total }})</span>
                </template>
                <template #headerButtons>
                    <button class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                        @click="showSearchModal" title="Rechercher"
                        ><i class="fad fa-search"></i>
                    </button>
                </template>
                <template #tableHeader>
                    <th>Code</th>
                    <th>Envoyée le</th>
                    <th># Colis</th>
                    <th>Statut</th>
                    <th>&nbsp;</th>
                </template>
                <template #tableBody>
                    <template v-if="!requests.data.length">
                        <tr>
                            <td colspan="5">
                                <div class="text-center text-2xl text-red-400 bg-red-100 p-10">
                                    <b>{{ userShow.name }}</b> n'a encore effectué aucune demande d'envoie de colis.
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-else v-for="(req, index) in requests.data" :key="index">
                        <tr>
                            <td>{{ req.code }}</td>
                            <td class="capitalize">{{ formattedDateTime(req.created_at) }}</td>
                            <td>{{ req.weight_package ? req.weight_package : 'Non renseigné' }}</td>
                            <td><StatusBadge :label="req.status_text" :color="req.status_color" /></td>
                            <td>
                                <Link class="flex justify-end" title="Détails"
                                    :href="route('travels.requests', req.travel) + '?filter[code]=' + req.code"
                                >
                                    <svg class="shrink-0 h-6 w-6" viewBox="0 0 24 24">
                                        <path class="fill-current text-sky" d="M8.07 16H10V8H8.07a8 8 0 110 8z"></path>
                                        <path class="fill-current text-sky-300" d="M15 12L8 6v5H0v2h8v5z"></path>
                                    </svg>
                                </Link>
                            </td>
                        </tr>
                    </template>
                </template>
            </Datatables>
        </div>

        <Pagination :links="requests.links" />

        <jet-dialog-modal :show="searchModal" @close="closeSearchModal" max-width="xl">
            <template #title>Rechercher une demande</template>
            <template #content>
                <GlobalFilter @search-launched="closeSearchModal" />
            </template>
        </jet-dialog-modal>
    </UserLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import Pagination from '@/Components/Pagination'
    import Datatables from '@/Components/Datatables'
    import UserLayout from '@/Layouts/UserLayout.vue'
    import StatusBadge from '@/Components/StatusBadge'
    import JetDialogModal from '@/Jetstream/DialogModal'
    import GlobalFilter from '@/Components/GlobalFilter'
    import CurrencyMixins from '@/Mixins/CurrencyMixins'
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import DateFormatMixins from '@/Mixins/DateFormatMixins'

    export default defineComponent({
        components: {
            Head,
            Link,
            UserLayout,
            Pagination,
            Datatables,
            StatusBadge,
            GlobalFilter,
            JetDialogModal
        },

        mixins: [DateFormatMixins],

        props: {
            roles: Object,
            userShow: Object,
            currency: Object,
            requests: Object
        },

        data() {
            return {
                searchModal: false
            }
        },

        methods: {
            showSearchModal () {
                this.searchModal = true
            },

            closeSearchModal() {
                this.searchModal = false
            },
        }
    })
</script>

